<template>
  <div class="flex flex-direction align-center justify-start welcome-viewConent view">
    <div class="text-center welcome-top-img"></div>
    <div class="flex align-center justify-center margin-top-lg" style="position: fixed;bottom: 80px;">
      <div v-if="isAndroid()" class="welcome-android-img">
      </div>
      <div v-else="">
        <wxlite class="hidden-sm-and-up" ref="wxlite"
                :activity="welcome" :diySetting="welcome"></wxlite>
      </div>
    </div>
  </div>
</template>

<script>
  import App from '../util/comfun'
  import brand from '../components/brand.vue'
  import wxlite from '../components/wxlite.vue'
  //import 'element-ui/lib/theme-chalk/display.css';
  export default {
    data () {
      return {
        welcome:{
          activityId:'welcome',
          className:'wxlite wxlite-welcome',
          buttonName:'点我，免费使用',
          activityName:'Fotoo征集一下',
          hideShareMenu:true,
        },
      }
    },
    components:{
      brand,
      wxlite,
    },
    methods:{
      isAndroid(){
        return /(Android)/i.test(navigator.userAgent)
      },
    },
    mounted(){
      setTimeout(()=>{
        if(this.$refs.wxlite){
          this.$refs.wxlite.doClick()
        }
      },1000)
    },

  }
</script>

<style scoped>
  .welcome-viewConent{
    width: 100vw;
    height: 100vh;
    background: #ffffff;
    position: relative;
    padding-top: 30px;
  }
  .welcome-top-img{
    width: 375px;
    height: 120px;
    background-image: url("https://assets.pfotoo.com/images/shunfeng.jpg");
    background-size: 100% 100%;
    margin-top: 20vh;
  }
  .welcome-android-img{
    width: 315px;
    height: 51px;
    background-image: url("https://assets.pfotoo.com/images/android-search.jpg");
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/welcome.vue